<template>
  <main class="page-main">
    <article class="page-article">
      <h1>Privacy Policy</h1>
      <p class="meta">Last updated: April 26, 2026</p>
      <p>
        This Privacy Policy explains how <strong>New Shivam Medicos</strong> (“we”, “us”, “our”) collects,
        uses, and shares information when you visit <strong>www.shivammedicos.in</strong> (the “Site”)
        or contact us by phone or in person. By using the Site, you agree to this policy. If you do not
        agree, please do not use the Site.
      </p>

      <h2>1. Who we are</h2>
      <p>
        New Shivam Medicos is a retail pharmacy located at South Basistha Nagar, near Durga Mandir,
        Basistha, Guwahati, Assam, India. Phone: <a href="tel:+918876499294">+91 8876499294</a>.
      </p>

      <h2>2. Information we may collect</h2>
      <ul>
        <li>
          <strong>Website usage:</strong> Pages viewed, approximate location (region/city), device type,
          browser type, and technical logs. We use Google Analytics (see below) which uses cookies.
        </li>
        <li>
          <strong>Communications:</strong> Information you give us by phone or in person (e.g. name, phone
          number) when you place an order or ask a question. This Site does not offer a prescription upload
          or online order form; bring prescriptions to the shop or discuss them by phone.
        </li>
      </ul>

      <h2>3. Cookies and similar technologies</h2>
      <p>
        We use cookies and similar technologies to run the Site, remember preferences, measure traffic, and
        (where enabled) show advertisements. Cookies are small files stored on your device.
      </p>
      <p>
        You can control cookies through your browser settings. Blocking some cookies may limit Site
        functionality.
      </p>

      <h2>4. Google Analytics</h2>
      <p>
        We use Google Analytics to understand how visitors use our Site. Google may collect data such as IP
        address (possibly truncated), device information, and on-site behaviour. Learn how Google uses data at
        <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer"
          >Google’s partner policy</a
        >.
      </p>

      <h2>5. Google AdSense and advertising</h2>
      <p>
        We may use <strong>Google AdSense</strong> or other Google advertising services to display ads on this
        Site. Google and its partners may use cookies (including advertising cookies) to show ads based on
        your visits to this Site and other sites. You can learn more about how Google uses information from
        sites that use its services at
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer"
          >policies.google.com/technologies/ads</a
        >.
      </p>
      <p>
        You may opt out of personalised advertising by visiting
        <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer"
          >Google Ads Settings</a
        >
        or
        <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">aboutads.info</a>.
      </p>

      <h2>6. How we use information</h2>
      <ul>
        <li>To process prescription-related requests and operate our pharmacy.</li>
        <li>To improve the Site, fix errors, and analyse traffic.</li>
        <li>To comply with law, court orders, or regulatory requests.</li>
        <li>To show non-personalised or personalised ads where permitted and configured.</li>
      </ul>

      <h2>7. Sharing of information</h2>
      <p>
        We may share information with service providers (e.g. hosting on Vercel, analytics and advertising
        vendors such as Google) who process data on our behalf under appropriate agreements. We may disclose
        information if required by law or to protect rights and safety.
      </p>

      <h2>8. Data retention</h2>
      <p>
        We retain information only as long as needed for the purposes above, unless a longer period is
        required by law. Pharmacy records from in-person or telephone services are kept according to
        applicable rules and our internal retention practices.
      </p>

      <h2>9. Security</h2>
      <p>
        We take reasonable steps to protect information. No method of transmission over the Internet is 100%
        secure; we cannot guarantee absolute security.
      </p>

      <h2>10. Children’s privacy</h2>
      <p>
        The Site is not directed at children under 13. We do not knowingly collect personal information from
        children. If you believe we have, please contact us and we will delete it where appropriate.
      </p>

      <h2>11. Your rights</h2>
      <p>
        Depending on applicable law (including Indian privacy rules where they apply), you may have rights to
        access, correct, or delete certain data, or to object to some processing. Contact us by phone to
        exercise rights related to pharmacy records; for website data, use the same contact number.
      </p>

      <h2>12. Third-party links</h2>
      <p>
        The Site may link to third-party sites (e.g. maps). We are not responsible for their privacy
        practices. Read their policies before using those sites.
      </p>

      <h2>13. Changes</h2>
      <p>
        We may update this Privacy Policy from time to time. The “Last updated” date at the top will change
        when we do. Continued use of the Site after changes means you accept the updated policy.
      </p>

      <h2>14. Contact</h2>
      <p>
        Questions about this policy: call <a href="tel:+918876499294">+91 8876499294</a> or visit us at the
        address in section 1.
      </p>
    </article>
  </main>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>
